/* lv-popup.js · Newsletter-Popup (zwei Schritte) + Rabattcode kopieren */
(function () {
  'use strict';
  function $(sel, sc) { return (sc || document).querySelector(sel); }

  function initPopup(scope) {
    var box = $('[data-lv-pop]', scope);
    if (!box || box.getAttribute('data-lv-ready') === '1') return;
    box.setAttribute('data-lv-ready', '1');
    var key = box.getAttribute('data-key') || 'lv-pop';
    var days = Number(box.getAttribute('data-days')) || 14;
    var delay = Number(box.getAttribute('data-delay'));
    if (isNaN(delay)) delay = 6;
    var shown = false, timer = null;
    var seen = function () {
      try { var t = Number(localStorage.getItem(key) || 0); return t && (Date.now() - t) < days * 864e5; } catch (e) { return false; }
    };
    var mark = function () { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} };
    var open = function () {
      if (shown) return; shown = true;
      if (timer) clearTimeout(timer);
      box.hidden = false;
      document.body.classList.add('lv-lock');
      var f = $('input[type="email"]', box) || $('[data-lv-pop-close]', box);
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    };
    var close = function () {
      box.hidden = true;
      document.body.classList.remove('lv-lock');
      mark();
    };
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-lv-pop-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) close();
    });
    if (box.getAttribute('data-step') === '2') { mark(); open(); return; }
    if (seen()) return;
    timer = setTimeout(open, Math.max(0, delay) * 1000);
    if (box.getAttribute('data-exit') === '1' && window.matchMedia && window.matchMedia('(min-width: 990px)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 4) open();
      });
    }
  }

  /* Rabattcode kopieren */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-lv-copy]') : null;
    if (!b) return;
    var code = b.getAttribute('data-lv-copy') || '';
    var done = b.getAttribute('data-done') || '';
    var ok = function () { if (done) { var old = b.textContent; b.textContent = done; setTimeout(function () { b.textContent = old; }, 2000); } };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(ok).catch(function () {}); }
    else {
      var t = document.createElement('textarea'); t.value = code; t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); ok(); } catch (e2) {}
      document.body.removeChild(t);
    }
  });

  function boot(scope) { initPopup(scope || document); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { boot(); }); }
  else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
